<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 md10>
        <v-card>
          <v-toolbar flat dense light color="grey lighten-5">
            <v-toolbar-title>Rehber Kaydı Detayı</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-flex d-flex>
              <v-btn @click="newContact()"> Yeni Rehber Ekle </v-btn>
              <v-btn color="primary" class="ml-2" @click="dialog = true">
                Tüm Rehberi Sil
              </v-btn>
              <v-dialog v-model="dialog" max-width="700px" min-width="700px">
                <v-card>
                  <v-card-title>
                    <span style="padding-bottom: 30px"><b>UYARI !!</b></span>
                    <v-spacer></v-spacer>

                    <v-alert
                      type="warning"
                      prominent
                      style="
                        padding-left: 20px;
                        word-break: break-word;
                        table-layout: fixed;
                      "
                    >
                      Tüm rehberi kalıcı olarak silmek tehlike yaratabilir, yine
                      de silmek istiyor musun ?
                    </v-alert>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      text
                      @click="deleteAll()"
                      :loading="loadingPopup"
                      :disabled="loadingPopup"
                      style="margin-bottom: 10px; width: 50%; padding: 25px 0px"
                    >
                      Sil
                    </v-btn>
                    <v-btn
                      color="error"
                      text
                      @click="dialog = false"
                      style="margin-bottom: 10px; width: 50%; padding: 25px 0px"
                    >
                      İptal
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout align-center justify-center>
                  <v-flex xs12 md11>
                    <v-row class="rows">
                      <v-col cols="12" sm="6" md="12">
                        <v-data-table
                          v-model="selected"
                          :headers="headers"
                          :items="items"
                          item-key="id"
                          class="elevation-1"
                          hide-default-footer
                        >
                          <template v-slot:expanded-item="{ item, headers }">
                            <td :colspan="headers.length">
                              <v-card-text>
                                {{ item.name }}
                              </v-card-text>
                            </td>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              medium
                              class="mr-3"
                              @click="detailGroup(item.id)"
                            >
                              mdi-pencil
                            </v-icon>
                            <v-icon medium @click="deleteGroup(item.id)">
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                        <pagination :pagination="pagination" :action="load">
                        </pagination>
                      </v-col>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Pagination from "../../Components/Datatables/Pagination.vue";

export default {
  name: "Detail",
  components: { Pagination },
  data: () => ({
    dialog: false,
    pagination: {
      current: 1,
      total: 0,
    },
    headers: [
      {
        text: "Ad",
        align: "left",
        value: "name",
      },
      { text: "Soyad", value: "surname", searchable: false }, // group_name
      { text: "Telefon", value: "phone", searchable: false },
      { text: "Grup", value: "group_name", searchable: false },
      { text: "İşlemler", value: "actions", searchable: false },
    ],
    items: [],
  }),
  created() {
    this.load();
  },
  methods: {
    ...mapActions({ send: "sendBackend" }),
    load() {
      this.send({
        route: `show/contacts?page=${this.pagination.current}`,
      }).then((res) => {
        this.items = res.data.data.contacts.data;
        this.pagination.current = res.data.data.contacts.current_page;
        this.pagination.total = res.data.data.contacts.last_page;
      });
    },
    async deleteGroup(id) {
      return new Promise((resolve) => {
        this.$store.commit("fireConfirmation", async () => {
          const route = "delete/contacts";
          const data = { id: Array.isArray(id) ? id : [id] };

          this.send({ route, data }).then(() => {
            this.items = Array.isArray(id)
              ? this.items.filter((obj) => !this.selected.includes(obj.id))
              : this.items.filter((obj) => obj.id !== id);
          });
          resolve();
        });
      });
    },
    detailGroup(id) {
      this.$router.push({ name: "contact.detail", params: { id } });
    },
    newContact() {
      this.$router.push({ name: "contact.create" });
    },
    deleteAll() {
      this.send({ route: "delete/all/groups" }).then((res) => {
        this.dialog = false;
        this.load();
      });
    },
  },
};
</script>
